<h4>Messages</h4>
<section class="form-group">
    <div class="panel-white panel-messages panel-messages--scrolling">
        <div class="row" *ngFor="let message of messages">
            <div class="col-md-8" [ngClass]="{ 'col-md-offset-4': message.senderId !== current.iD_QuoteRequestRecipient }">
                <div
                    class="panel"
                    [ngClass]="{
                        'panel-info': message.senderId === current.iD_QuoteRequestRecipient,
                        'panel-success': message.senderId !== current.iD_QuoteRequestRecipient,
                    }">
                    <div class="panel-heading">
                        <span class="panel-message__date">
                            <span *ngIf="message.senderId !== current.iD_QuoteRequestRecipient">Sent</span>
                            <span *ngIf="message.senderId === current.iD_QuoteRequestRecipient">Received</span>
                            {{ message.postDate | date: 'medium' }}</span
                        >{{ message.text }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 col-md-offset-4">
                <div class="panel panel-success">
                    <div class="panel-body" style="padding: 0">
                        <textarea
                            legacy-css
                            rows="3"
                            class="form-control form-control-v2"
                            placeholder="Enter a message..."
                            [(ngModel)]="newMessage"></textarea>
                        <button
                            type="button"
                            class="panel-message btn-bx-primary"
                            [disabled]="isNewMessageSubmitting || newMessage === ''"
                            (click)="sendMessage()">
                            Send
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
